import Washer from './Washer';

export default Washer;